<template>
  <WdsStack
    direction-column
    align-center
    justify-space-between
    class="tw-bg-white tw-shadow tw-gap-7 tw-p-7.5"
    data-test="no-compliance-found"
  >
    <slot name="icon">
      <WdsAvatar :path="randomAvatar" xxl />
    </slot>
    <div>
      <div class="tw-text-gray-900 tw-font-display tw-text-xl tw-leading-7">
        <slot name="main" />
      </div>
      <div class="tw-text-gray-600 tw-font-circular tw-text-lg tw-leading-6">
        <slot name="sub" />
      </div>
    </div>
    <WdsStack
      v-if="$slots.actions"
      direction-row
      justify-space-between
      align-center
      class="tw-gap-md"
    >
      <slot name="actions" />
    </WdsStack>
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsAvatar, WdsStack } from '@worksome/wds-components'
import { getRandomAvatarPath } from '@/utils/avatar'

const randomAvatar = getRandomAvatarPath()
</script>
